import {RETRIEVE_DIFFICULTIES_ERROR, RETRIEVE_DIFFICULTIES_REQUEST, RETRIEVE_DIFFICULTIES_SUCCESS} from "./actions";
import {REHYDRATE} from 'redux-persist'


const initialState = {
    isLoading: false,
    difficulties: []
};


export default function difficultyReducer(state = initialState, action) {
    switch (action.type) {
        case RETRIEVE_DIFFICULTIES_REQUEST:
            return {...state, isLoading: true};
        case RETRIEVE_DIFFICULTIES_SUCCESS:
            return {...state, isLoading: false, difficulties: [...action.difficulties]};
        case RETRIEVE_DIFFICULTIES_ERROR:
            return {...state, isLoading: false};
        case REHYDRATE:
            if (action.payload) {
                const incoming = action.payload.difficulty;
                if (incoming) {
                    return {...state, difficulties: [...incoming.difficulties]};
                }
            }
            return state;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/difficulties/reducer.js